import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const MerchSection = () => {
  return (
    <section id="merch" className="py-32 px-4 bg-[#0a0515] relative overflow-hidden">
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="absolute -inset-4 bg-pink-500/20 blur-3xl rounded-full opacity-50" />
            <div className="relative glass-panel rounded-[3rem] overflow-hidden border-white/10 aspect-square">
              <img 
                src="https://i.etsystatic.com/61529167/r/il/de395b/8178662582/il_1588xN.8178662582_5d0j.jpg" 
                alt="Dai Kho Limited Signature Hoodie" 
                className="w-full h-full object-cover transition-transform duration-700 hover:scale-110"
              />
              <div className="absolute bottom-0 left-0 right-0 p-8 bg-gradient-to-t from-black/80 to-transparent">
                <span className="px-3 py-1 bg-white text-black text-[10px] font-black uppercase tracking-widest rounded-full">
                  Official Merch: Signature Hoodie
                </span>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <div className="inline-block px-4 py-1.5 rounded-full border border-pink-500/30 bg-pink-500/10 text-pink-300 text-[10px] font-bold tracking-widest uppercase mb-8">
              Premium Lifestyle
            </div>
            <h2 className="text-5xl md:text-7xl font-black mb-8 leading-none uppercase tracking-tighter">
              Wear the <br /> <span className="text-gradient">Energy.</span>
            </h2>
            <p className="text-slate-400 text-xl font-light mb-10 leading-relaxed">
              Our streetwear collection is designed for the modern practitioner. High-quality materials meet spiritual iconography in a fusion of style and soul.
            </p>
            
            <div className="space-y-6 mb-12">
              <div className="flex items-center gap-4 text-slate-300">
                <div className="w-10 h-10 rounded-xl bg-pink-500/10 flex items-center justify-center text-pink-400">
                  <SafeIcon name="Check" className="w-5 h-5" />
                </div>
                <span className="font-medium">Premium Cotton Blends</span>
              </div>
              <div className="flex items-center gap-4 text-slate-300">
                <div className="w-10 h-10 rounded-xl bg-pink-500/10 flex items-center justify-center text-pink-400">
                  <SafeIcon name="Check" className="w-5 h-5" />
                </div>
                <span className="font-medium">Original Spiritual Designs</span>
              </div>
            </div>

            <a 
              href="https://daikho.store" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-4 px-12 py-6 bg-pink-600 hover:bg-pink-500 text-white font-bold rounded-2xl transition-all hover:scale-105 shadow-[0_0_30px_rgba(219,39,119,0.3)]"
            >
              Shop DKL Store <SafeIcon name="ShoppingBag" className="w-6 h-6" />
            </a>
            
            <p className="mt-6 text-slate-500 text-sm">
              Also available on <a href="https://daikholimited.etsy.com" target="_blank" rel="noopener noreferrer" className="text-slate-300 underline">Etsy</a>
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default MerchSection;